import { render, staticRenderFns } from "./CalcIssueFreightPop.vue?vue&type=template&id=2b6733ef&scoped=true"
import script from "./CalcIssueFreightPop.vue?vue&type=script&lang=js"
export * from "./CalcIssueFreightPop.vue?vue&type=script&lang=js"
import style0 from "./CalcIssueFreightPop.vue?vue&type=style&index=0&id=2b6733ef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6733ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6733ef')) {
      api.createRecord('2b6733ef', component.options)
    } else {
      api.reload('2b6733ef', component.options)
    }
    module.hot.accept("./CalcIssueFreightPop.vue?vue&type=template&id=2b6733ef&scoped=true", function () {
      api.rerender('2b6733ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/CalcIssueFreightPop.vue"
export default component.exports